import styled from 'styled-components'
import pxToRem from '../../utils/pxToRem'
import ArrowDown from '../../images/icons/arrow-down-black.svg'
import {deviceMax} from '../../theme/breakpoints'

export const StyledContainer = styled.div`
  gap: ${pxToRem(20)};
  margin: 0 0 ${pxToRem(20)} 0;
  border-radius: ${pxToRem(5)};
  width: ${pxToRem(792)};
  max-width: ${pxToRem(792)};
  padding: ${pxToRem(20)};
  background: ${({theme}) => theme.colors.unique.white};
  overflow-x: hidden;

  @media ${deviceMax.tablet} {
    width: 100%;
  }
`

export const StyledTitle = styled.p`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
  font-weight: ${({theme}) => theme.fonts.weight.bold};
  font-size: ${({theme}) => theme.fonts.sizes.titleH2};
  line-height: ${({theme}) => theme.fonts.lineHeight.titleH2};
`
export const StyledRichText = styled.p`
  margin: ${pxToRem(10)} 0;
  font-weight: ${({theme}) => theme.fonts.weight.normal};
  font-size: ${({theme}) => theme.fonts.sizes.base};
  line-height: ${({theme}) => theme.fonts.lineHeight.base};
`

export const DropDownContainer = styled.div`
  justify-content: center;
  display: flex;
  padding: ${pxToRem(5)} ${pxToRem(10)};
  cursor: pointer;
  position: relative;
  border-radius: ${pxToRem(20)};
  ${({$active, theme}) => {
    if ($active)
      return `
    background: ${theme.colors.custom.lime};
    `
  }}
`

export const DropDownHeader = styled.div`
  align-items: center;
  display: flex;
  gap: ${pxToRem(5)};
  font-weight: ${({theme}) => theme.fonts.weight.bold};
  font-size: ${({theme}) => theme.fonts.sizes.button};
`

export const StyledArrow = styled(ArrowDown)`
  transition: all ease-in-out 0.2s;
  ${({$isOpen}) => $isOpen && 'transform: rotate(180deg)'};
`

export const DropDownListContainer = styled.div`
  position: absolute;
  top: ${pxToRem(50)};
  right: ${pxToRem(15)};
  background: ${({theme}) => theme.colors.secondary.whitesmoke};
  max-height: ${pxToRem(300)};
  padding: ${pxToRem(5)} ${pxToRem(5)} 0 ${pxToRem(5)};
  overflow-x: scroll;
  border-radius: ${pxToRem(20)};

  ::-webkit-scrollbar {
    width: ${pxToRem(5)};
  }

  ::-webkit-scrollbar-track {
    border-radius: ${pxToRem(10)};
  }

  ::-webkit-scrollbar-thumb {
    background: ${({theme}) => theme.colors.custom.lime};
    border-radius: ${pxToRem(10)};
  }
`

export const DropDownList = styled.ul``

export const ListItem = styled.li`
  cursor: pointer;
  padding: ${pxToRem(10)} ${pxToRem(15)};
  border-radius: ${pxToRem(20)};
  font-weight: ${({theme}) => theme.fonts.weight.bold};
  font-size: ${({theme}) => theme.fonts.sizes.button};
  ${({$active, theme}) => {
    if ($active)
      return `
    background: ${theme.colors.custom.lime};
    `
  }}
`

export const StyledTabs = styled.div`
  position: relative;
  align-items: center;
  display: flex;
  margin: ${pxToRem(10)} 0;
  gap: ${pxToRem(25)};
  width: fit-content;
  padding: ${pxToRem(10)} ${pxToRem(20)};
  background: ${({theme}) => theme.colors.secondary.whitesmoke};
  border-radius: ${pxToRem(30)};
  @media ${deviceMax.mobileL} {
    max-width: 100%;
    gap: 0;
  }
`

export const StyledTabTitleContainer = styled.div`
  padding: ${pxToRem(5)} ${pxToRem(10)};
  border-radius: ${pxToRem(20)};
  ${({$active, theme}) => {
    if ($active)
      return `
    background: ${theme.colors.custom.lime};
    `
    else
      return `
    cursor: pointer;`
  }} @media ${deviceMax.mobileL} {
    padding: ${pxToRem(5)} ${pxToRem(10)};
  }
`

export const StyledTabTitle = styled.div`
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  overflow: hidden;
  display: flex;
  height: ${pxToRem(23)};
  width: ${pxToRem(36)};
  font-weight: ${({theme}) => theme.fonts.weight.bold};
  font-size: ${({theme}) => theme.fonts.sizes.button};
  line-height: ${({theme}) => theme.fonts.lineHeight.cta};
`


export const StyledContentFinancial = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(20)};
  
`

